import { useCallback as a } from "react";
function u(n, e) {
  if (typeof n == "function")
    return n(e);
  typeof n == "object" && n !== null && "current" in n && (n.current = e);
}
function i(...n) {
  const e = /* @__PURE__ */ new Map();
  return (o) => {
    if (n.forEach((t) => {
      const c = u(t, o);
      c && e.set(t, c);
    }), e.size > 0)
      return () => {
        n.forEach((t) => {
          const c = e.get(t);
          c ? c() : u(t, null);
        }), e.clear();
      };
  };
}
function l(...n) {
  return a(i(...n), n);
}
export {
  u as a,
  i as m,
  l as u
};
